<template>
	<div>
		<section class="ss-header-clear" :class="['ss-header__level_' + mode]">
			<div class="ss-header" :class="[fixedNav ? 'ss-header-fixed' : '']">
				<div class="ss-header-top line-1">
					<div class="ss-container">
						<router-link class="ss-header__brand" to="/">
							<img src="~@/assets/logo.png" class="ss-header__brand_black" />
							<img src="~@/assets/img/main/logo-white.png" class="ss-header__brand_white" />
						</router-link>
						<div class="ss-header__tools">
							<template v-if="mode !== 'black'">
								<div class="ss-header__search" v-if="mode !== 99">
									<input @keyup.enter="searchConfirm" v-model="keyword" placeholder="搜索" class="ss-header__search_input" />
									<img src="@/assets/img/main/search.png" @click="searchConfirm" class="ss-header__search_img" />
								</div>
								<template v-if="!userInfo.id">
									<router-link :to="{name: 'register'}" class="ss-header__text">
										<img class="ss-header__icon" src="../../assets/img/header/zhuce@2x.png" />
										<img class="ss-header__icon ss-header__icon_sel" src="../../assets/img/header/zhuce_sel@2x.png" />
										<img class="ss-header__icon ss-header__icon_black" src="../../assets/img/header/zhuce_black@2x.png" />
										免费注册
									</router-link>
									<router-link :to="{name: 'login'}" class="ss-header__text">
										<img class="ss-header__icon" src="../../assets/img/header/denglu@2x.png" />
										<img class="ss-header__icon ss-header__icon_sel" src="../../assets/img/header/denglu_sel@2x.png" />
										<img class="ss-header__icon ss-header__icon_black" src="../../assets/img/header/denglu_black@2x.png" />
										用户登录
									</router-link>
								</template>
								<template v-else>
									<router-link :to="{name: 'settingCollection'}" class="ss-header__text">
										<img class="ss-header__icon" src="../../assets/img/header/collection@2x.png" />
										<img class="ss-header__icon ss-header__icon_sel" src="../../assets/img/header/collection_sel@2x.png" />
										收藏
									</router-link>
									<router-link :to="{name: 'systemMessage'}" class="ss-header__text">
										<img class="ss-header__icon" src="../../assets/img/header/message@2x.png" />
										<img class="ss-header__icon ss-header__icon_sel" src="../../assets/img/header/message_sel@2x.png.png" />
										消息
									</router-link>
									<router-link :to="{name: 'settingIndex'}" class="ss-header__text">
										<img class="poster-image" :src="userInfo | imgUrl('headImage')" />
										{{userInfo.username}}
									</router-link>
								</template>
								<div class="ss-header__text">
									<img class="ss-header__icon" src="../../assets/img/header/guanzhu@2x.png" />
									<img class="ss-header__icon ss-header__icon_sel" src="../../assets/img/header/guanzhu_sel@2x.png" />
									<img class="ss-header__icon ss-header__icon_black" src="../../assets/img/header/guanzhu_black@2x.png" />
									关注我们
									<div class="ss-header__text_qrcode">
										<div class="ss-header__text_qrcode_item">
											<img :src="gzhXCXUrl" />
											<span class="ss-header__text_qrcode_text">小程序</span>
										</div>
										<!-- <div class="ss-header__text_qrcode_item">
											<img :src="gzhUrl" />
											<span class="ss-header__text_qrcode_text">公众号</span>
										</div> -->
										<div class="ss-header__text_qrcode_item">
											<img :src="gzhUrl" />
											<span class="ss-header__text_qrcode_text">服务号</span>
										</div>
									</div>
								</div>
								<!-- <div class="ss-header__text">
									<img class="ss-header__icon" src="../../assets/img/header/xiazai@2x.png" />
									<img class="ss-header__icon ss-header__icon_sel" src="../../assets/img/header/xiazai_sel@2x.png" />
									<img class="ss-header__icon ss-header__icon_black" src="../../assets/img/header/xiazai_black@2x.png" />
									下载APP
									<div class="ss-header__text_qrcode">
										<img :src="downloadUrl" />
									</div>
								</div> -->
							</template>
							<template v-else>
								<router-link class="ss-header__text" :to="{name: 'home'}">
									<img class="ss-header__icon ss-header__icon_black" src="../../assets/img/header/home@2x.png" />
									<img class="ss-header__icon ss-header__icon_sel" src="../../assets/img/header/home_sel@2x.png" />
									返回首页
								</router-link>
							</template>
						</div>
					</div>
				</div>
				<div class="ss-header-bottom">
					<div class="ss-container">
						<div class="ss-header__menu">
							<div class="ss-header__item" :class="{'ss-header__item_active': menuIndex === index}" v-for="(item, index) in menuList" :key="index">
								<router-link :to="{name: item.name}">
								 {{item.menuName}}
								 </router-link>
								<ul class="ss-header__sub_content" v-if="childrenMenus_[index].length">
									<li v-for="(it, idx) in childrenMenus_[index]" :key="idx">
										<template v-if="it">
											<template v-if="it.href">
												<a :href="it.href" target="_blank">{{it.menuName}}</a>
											</template>
											<template v-else-if="it.mode !== 'function'">
												<router-link :to="{name: it.name}">
												 {{it.menuName}}
												 </router-link>
											</template>
											<template v-else>
												<span @click="childrenMenusClick(it.name)">
												 {{it.menuName}}
												 </span>
											</template>
										</template>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<ss-breadcrumb v-if="!hideBreadcrumb" />
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex'
	import {
		getMenuList,
		findChildrenItem
	} from '@/router/menuOperation.js'
	import {BASE_URL} from "@/config";
	export default {
		name: 'Main',
		data() {
			return {
				fixedNav: true,
				menuList: getMenuList(),
				hideBreadcrumb: false,
				mode: 2,
				menuIndex: 0,
				childrenMenus: [],
				keyword: '',
				downloadUrl: BASE_URL + '/u/cms/resources/downloadAppQrcode.png',
				// fwhUrl: require('@/assets/img/main/gzh.jpg'),
				gzhUrl: require('@/assets/img/main/gzh.jpg'),
				gzhXCXUrl: require('@/assets/img/main/ewm-wechat-miniapp.jpg'),
			}
		},
		computed: {
			...mapState({
				userInfo: state => state.user.userInfo
			}),
			childrenMenus_() {
				if(this.childrenMenus.length == 0) return [];
				let childrenMenus = this.$deepClone(this.childrenMenus);
				if(this.userInfo.id){
					if(childrenMenus[childrenMenus.length - 1].length === 5){
						childrenMenus[childrenMenus.length - 1].push({
							menuName: "退出登录",
							mode: "function",
							name: 'LogoutAction'
						})
					}
				}else{
					childrenMenus[childrenMenus.length - 1].length = 5;
				}
				return childrenMenus;
			}
		},
		watch: {
			'$route.path': {
				handler: function(val, oldVal){
					let { hideBreadcrumb = false, level = 2, mode = 2 } = this.$route.meta || {};
					this.hideBreadcrumb = hideBreadcrumb;
					this.mode = mode;
					this.menuIndex = this.menuList.findIndex((o, index) => {
						if(o.to === val || (this.childrenMenus[index] && this.childrenMenus[index].length && this.childrenMenus[index].findIndex(o1 => o1.path === val) !== -1)){
							return true;
						}
					})
					window.scroll({
						top: 0,
						behavior: 'smooth'
					});
				},
				deep: true,
				immediate: true
			}
		},
		created() {
			let childrenMenus = [];
			this.menuList.forEach(o => {
				childrenMenus.push(findChildrenItem(o))
			})
			var val = this.$route.path;
			this.childrenMenus = childrenMenus;
			this.menuIndex = this.menuList.findIndex((o, index) => {
				if(o.to === val || (this.childrenMenus[index] && this.childrenMenus[index].length && this.childrenMenus[index].findIndex(o1 => o1.path === val) !== -1)){
					return true;
				}
			})
		},
		methods: {
			...mapActions('user', ['LogoutAction']),
			searchConfirm(e) {
				if(!this.keyword) return this.$toast('搜索内容不能为空');
				this.$router.push({
					path: '/search',
					query: {
						keyword: this.keyword
					}
				})
			},
			childrenMenusClick(fun) {
				this[fun]({that: this});
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.ss-header-clear {
		height: 50px;

		&.ss-header__level_black {
			.ss-header__brand_white {
				height: 28px;
				margin-top: 7px;
			}
			.ss-header-bottom{
				overflow: hidden;
			}
			.ss-header-top {
				padding: 5px 0 10px;
				background-color: #333333;

				.ss-header__text {
					color: #fff;
					position: relative;
					.ss-header__icon{
						display: none;
					}
					.ss-header__icon_black{
						display: inline-block;
					}
				}
			}
			.ss-header__search{
				border-color: rgba(114,114,114,1);
				.ss-header__search_input {
					background-color: transparent;
				}
			}
		}
		&.ss-header__level_99{
			height: 80px;
			.ss-header-bottom{
				overflow: hidden;
			}

			.ss-header__brand_black {
				height: 40px;
			}
		}

		&.ss-header__level_2, &.ss-header__level_3 {
			height: 155px;

			.ss-header__brand_black {
				height: 40px;
			}

			.ss-header-bottom {
				padding: 10px 0;
				height: 75px;
				opacity: 1;
			}
		}
	}

	.ss-header {

		&.ss-header-fixed {
			@include fixed(0, 0, null, 0);
			z-index: 100;
		}

		.ss-header-top {
			padding: 20px 0;
			background-color: #fff;
			@include tst();
		}

		.ss-header__brand {
			float: left;

			img {
				height: 0;
				@include tst();
				display: block;
			}
		}

		.ss-header__tools {
			float: right;
			margin-top: 7px;
		}

		.ss-header__search {
			position: relative;
			border: solid 1px #d3d3d3;
			display: inline-block;
			vertical-align: top;

			.ss-header__search_input {
				width: 240px;
				border: none;
				height: 25px;
				line-height: 25px;
				padding: 0 30px 0 10px;
			}

			.ss-header__search_img {
				@include abs(4px, 4px);
				width: 18px;
				display: block;
			}
		}

		.ss-header__text {
			max-width: 130px;
			// @include ellipsis();
			display: inline-block;
			padding: 0 18px;
			font-size: 14px;
			line-height: 22px;
			color: #222220;
			cursor: pointer;
			position: relative;

			.poster-image{
				width: 20px;
				height: 20px;
				border-radius: 100%;
				display: inline-block;
				vertical-align: middle;
			}
			.ss-header__icon {
				width: 15px;
				height: 15px;
				margin-right: 4px;
				display: inline-block;
				vertical-align: middle;
			}
			.ss-header__text_qrcode{
				@include abs(40px, 50%);
				width: 350px;
				background-color: #fff;
				margin-right: -210px;
				z-index: 2;
				border-radius: 6px;
				height: 0;
				transition: all .3s linear;
				overflow: hidden;
				box-shadow: 0 0 5px rgba(0, 0, 0, .5);
				display: flex;
				justify-content: space-around;
				align-items: center;
				padding: 0;
				box-sizing: border-box;
			}

			.ss-header__text_qrcode_item{
				display: flex;
				flex-direction: column;
				align-items: center;
				flex: 0 0 auto;
				
				img{
					width: 120px;
					height: 120px;
					display: block;
					margin-bottom: 8px;
				}
				
				.ss-header__text_qrcode_text{
					font-size: 14px;
					color: #333;
					text-align: center;
					line-height: 1.5;
				}
			}

			.ss-header__icon_sel,.ss-header__icon_black{
				display: none;
			}

			&:hover {
				color: #0260fe !important;
				.ss-header__icon{
					display: none!important;;
				}
				.ss-header__icon_sel{
					display: inline-block!important;
				}
				.ss-header__text_qrcode{
					height: 175px;
					padding: 15px 10px;
				}
			}
		}

		.ss-header-bottom {
			background-color: #fff;
			height: 0;
			opacity: 0;
			@include tst();
		}

		.ss-header__menu {
			.ss-header__item {
				min-width: 130px;
				display: inline-block;
				position: relative;
				text-decoration: none;
				text-align: center;
				font-size: 18px;
				font-weight: 400;
				color: #170B0F;
				line-height: 55px;
				height: 55px;
				padding: 0 20px;
				a{
					display: block;
				}
				.ss-header__sub_content{
					opacity: 0;
					max-height: 0;
					@include tst();
					overflow: hidden;
					@include abs(55px, null, null, 0);
					min-width: 100%;
					background-color: #0456DE;
					li{
						white-space: nowrap;
						padding: 0 15px;
						text-align: center;
						height: 38px;
						line-height: 38px;
						font-size: 18px;
						font-weight: 400;
						color: #FFFFFF;
						cursor: pointer;
						&:hover{
							background: #3580FF;
						}
					}
				}
				&:hover{
					.ss-header__sub_content{
						border-top: 5px solid #0260FE;
						padding: 20px 0;
						opacity: 1;
						max-height: 400px;
					}
				}
				&.ss-header__item_active::after {
					content: '';
					width: 70px;
					height: 5px;
					@include abs(null, 50%, 0);
					margin-right: -35px;
					background-color: #0260fe;
				}
			}
		}
	}
</style>
